import { gql } from "@apollo/client";

const TEST = gql`
  mutation test {
    test
  }
`;

export default TEST;
